<template>
    <div class="termsPage">
      <section class="wrapper">
            <span v-if = "getLanguage == '日本語'">
                <h2 class="title">利用規約</h2>
                <TermsTextJp class="text" />
            </span>
            <span v-if = "getLanguage == 'English'">
                <h2 class="title">Terms of service</h2>
                <TermsTextEn class="text" />
            </span>
            <span v-if = "getLanguage == '中文'">
                <h2 class="title">使用条款</h2>
                <TermsTextCh class="text" />
            </span>
      </section>
    </div>
</template>
<script>
import TermsTextJp from "./TermsText.vue";
import TermsTextEn from "./TermsTextEn.vue";
import TermsTextCh from "./TermsTextCh.vue";
import { mapGetters } from "vuex";

export default { 
    components: {
        TermsTextJp,
        TermsTextEn,
        TermsTextCh
    },
  computed: {
    ...mapGetters(["getLanguage"]),
  }
}

</script>
<style lang="scss" scoped>
$xs: "320px";
$sm: "480px";
$md: "800px";
$lg: "1024px";
.termsPage {
    background-color: #f9f9f9!important;
    padding: 36px 48px;
    @media screen and (max-width: $sm) {
        padding: 0px;
    }
}
.title {
    font-size: 60px;
    font-weight: bold;
    color: #333;
}
.text {
    margin-top: 16px;
}
.wrapper {
    padding: 0px 48px 36px;
    max-width: 1280px;
    margin: 36px auto;
    line-height: 1.75;
    color: #444;
    @media screen and (max-width: $sm) {
        padding: 16px;
    }
    & + & {
        border-top: solid 1px #ccc;
        padding-top: 36px;
    }
}
.display {
    margin-top: 24px;
    font-size: 14px;
    dd {
        margin-bottom: 16px;
    }
}
</style>